<template>
  <b-overlay rounded="lg">
  <b-card title="Bulk Update Warranty - History" class="mb-2 history-container">
      <b-col cols="12">
        <div class="d-flex mb-2 align-items-center justify-content-between">
          <div>
            <b-button size="md" variant="primary" type="filled" @click="$router.push({ name: 'bulk-update-warranty' })">Back</b-button>
          </div>
          <div class="d-flex align-items-center">
            <b-form-input placeholder="Search by PCode, Cert No, or Item Model" v-model="keyword" class="mr-2" style="max-width:360px" />
            <b-button @click="searchHistory" variant="primary" size="md">Search</b-button>
          </div>
        </div>

        <b-row class="conditionView">
          <b-table 
            :items="historyItems" 
            :fields="fields" 
            small 
            responsive
            :busy="loading"
            show-empty
          >
            <template #cell(barcode)="{ item }">
              {{ item.barcode || '-' }}
            </template>
            <template #cell(certNo)="{ item }">
              {{ item.certNo || '-' }}
            </template>
            <template #cell(itemModel)="{ item }">
              {{ item.itemModel || '-' }}
            </template>
            <template #cell(pcode)="{ item }">
              {{ item.pcode || '-' }}
            </template>
            <template #cell(oldGeneralWarrantyDuration)="{ item }">
              {{ item.oldGeneralWarrantyDuration || '-' }} months
            </template>
            <template #cell(newGeneralWarrantyDuration)="{ item }">
              {{ item.newGeneralWarrantyDuration || '-' }} months
            </template>
            <template #cell(newGeneralWarrantyDate)="{ item }">
              {{ formatDateNoHour(item.newGeneralWarrantyDate) }}
            </template>
            <template #cell(updateStatus)="{ item }">
              <b-badge :variant="item.updateStatus === 'success' ? 'success' : 'danger'">
                {{ item.updateStatus }}
              </b-badge>
            </template>
            <template #cell(createdAt)="{ item }">
              {{ formatDate(item.createdAt) }}
            </template>
            <template #cell(updatedBy)="{ item }">
              {{ item.updatedBy || '-' }}
            </template>
          </b-table>
        </b-row>

        <!-- Pagination -->
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="center"
          @input="loadHistory"
        />
      </b-col>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapActions } from 'vuex'
import { dateFormat } from '@/utils/utils'

import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BPagination,
  BFormSelect,
} from 'bootstrap-vue';


export default {
  name: 'BulkUpdateWarrantyHistory',
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BFormSelect,
  },
  data() {
    
    return {
      
      fields: [
        { key: 'barcode', label: 'Barcode', thStyle: { width: '120px' } },
        { key: 'certNo', label: 'Cert No', thStyle: { width: '120px' } },
        { key: 'itemModel', label: 'Item Model', thStyle: { width: '150px' } },
        { key: 'pcode', label: 'PCode', thStyle: { width: '80px' } },
        { key: 'oldGeneralWarrantyDuration', label: 'Old Duration', thStyle: { width: '120px' } },
        { key: 'newGeneralWarrantyDuration', label: 'New Duration', thStyle: { width: '120px' } },
        { key: 'newGeneralWarrantyDate', label: 'New Warranty Date', thStyle: { width: '150px' } },
        { key: 'updateStatus', label: 'Status', thStyle: { width: '100px' } },
        { key: 'createdAt', label: 'Created At', thStyle: { width: '150px' } },
        { key: 'updatedBy', label: 'Updated By', thStyle: { width: '120px' } },
      ],
      keyword: '',
      loading: false,
      // Pagination properties
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      historyItems: [], // Store the current page items
    }
  },
  created() {
    document.title = "Bulk Update Warranty History | RSP";
  },
  watch: {
    currentPage() {
      this.loadHistory();
    },
  },
  mounted() {
    this.loadHistory()
  },
  methods: {
    ...mapActions({
      fetchBulkUpdateHistory: "warranty/fetchBulkUpdateHistory"
    }),
    formatDateNoHour(d) {
      return d ? dateFormat(d) : ''
    },
    formatDate(iso) {
      if (!iso) return '-';
      const date = new Date(iso);
      return date.toLocaleString();
    },
    processMetadata(metadata) {
      let { totalData } = metadata;
      this.totalRows = totalData;
      this.loading = false;
    },
    async loadHistory() {
      this.loading = true
      try {
        const data = await this.fetchBulkUpdateHistory({
          page: this.currentPage,
          perPage: this.perPage,
          keyword: this.keyword
        })
        
        // Update the items for current page
        this.historyItems = data.data || data;
        
        // If the API returns metadata, use it for pagination
        if (data.metadata) {
          this.processMetadata(data.metadata);
        } else {
          // Fallback: if no metadata, assume all data is returned
          this.totalRows = data.length || 0;
          this.loading = false;
        }
      } catch (error) {
        console.error('Failed to load history:', error)
        this.$bvToast.toast('Failed to load history', { title: 'Error', variant: 'danger', solid: true })
        this.loading = false
      }
    },
    async searchHistory() {
      // Reset to first page when performing a new search
      this.currentPage = 1;
      await this.loadHistory();
    },
  },
}
</script>

<style scoped>
.history-container b-table td, .history-container b-table th {
  white-space: nowrap;
  text-align: left;
}


</style>
